import { convertLocale } from '@pe-libs/react-components/build/lib/helper';
import useIntlMessage from '@pe-libs/react-components/build/lib/intl/hooks/useIntlMessage';
import { NextPage } from 'next';
import Head from 'next/head';
import React from 'react';
import { getQueryParameters } from '#helpers/query';
import { setUserIntl } from '#modules/app/actions';
import { industries } from '#modules/auth/actions';
import PeOnboarding from '#modules/auth/components/PeOnboarding';
import { wrapper } from '../store';
import { StateType } from '../types';
import messages from './messages';

type Props = {
  state: StateType;
};

const OnboardingPage: NextPage<Props> = () => {
  const formatMessage = useIntlMessage();

  return (
    <>
      <Head>
        <title>{formatMessage(messages.seoTitle)}</title>
        <meta name="description" content={formatMessage(messages.seoDescription)} />
      </Head>
      <PeOnboarding />
    </>
  );
};

export const getServerSideProps = wrapper.getServerSideProps((store) => async ({ req, query }) => {
  await store.dispatch(industries({ contextRequest: req }));
  const lang = getQueryParameters(query, 'lang');
  const locale = convertLocale(lang, 'locale');

  store.dispatch(setUserIntl({ locale }));

  return { props: {} };
});

export default OnboardingPage;
